export default "__VITE_ASSET__ea4f99cc__"